/**
 *
 * @readonly
 * @enum {string}
 */
module.exports = {
    CS: 'cs',
    EN: 'enUS',
    SK: 'sk',
    HU: 'hu',
    IT: 'it',
    PL: 'pl',
    PT: 'pt',
    ES: 'es',
    DE: 'de',
    FR: 'fr',
    RO: 'ro',
    HR: 'hr',
};
